/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit GenderBirthSeparator/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function GenderBirthSeparator({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/Phones/Content/Phone/Edit/Content/EditOrAdd/Content/Content/Profiles/Content/Profile/ProfileData/GenderBirthSeparator"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let personBirthDateValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'birth_date',
})
let personGenderValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'gender',
})
let aggregateData = fromAggregate.and(personBirthDateValueData, personGenderValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}